import type { ShortCircuitScenarioResults } from '../../..';
import type { ForFaultsEvaluation } from '../ForFaultsEvaluation';
import { GridElementsSummaryEvaluation } from './evaluateGridElements';

export const evaluateEnergyConsumers = (
  scenarios: ShortCircuitScenarioResults[],
  evaluationEngine: ForFaultsEvaluation
) =>
  GridElementsSummaryEvaluation.fromScenarios(
    scenarios,
    'EnergyConsumer'
  ).evaluate(evaluationEngine);
